import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import DropdownComponent from "./DropdownComponent";
import SizeTableSwitcherComponent from "./SizeTableSwitcherComponent";
import { removeAlgoliaAttributes } from '../utils/algoliaTrackings';

export default class PdpExtendedComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    let elem = document.querySelector('.jsToBagBtn');
    let pdpElement = document.querySelector('.c-pdp-main');
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    if(elem != null) {
      const sku = pdpElement.getAttribute('data-product-code');
      doAjax({
          type: 'POST',
          url: contextPath + '/action/ajax/specialpdpcheck',
          data: {
            sku: sku
          }
        })
        .done(resp => {
          if(resp === "OK") {
            doAjax({
                type: 'POST',
                url: contextPath + '/action/ajax/specialpdp',
                data: {
                  sku: sku
                }
              })
              .done(resp => {
                $('.js-editorial-content').append($(resp).find('#pdp-editorial'));
                this.$emit(this.$customEvents.CAROUSEL.triggerCarousel);
              })
              .fail(xhr => {
                this.log('Related page not found');
              })
              .always((xhr) => {

              });
          }
        })
        .fail(xhr => {
          this.log('Related page not found');
        })
        .always((xhr) => {

        });
    }
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, (e) => {
      this.vexComponentLoader();
    });
    // Listen for modal height changes from ModalComponent
    this.$on(this.$customEvents.MODAL_EVENTS.heightChanged, (data) => {
      this.repositionSizeGuideModal();
    });
  }

  vexComponentLoader() {
    if (!document.body.classList.contains('vex-components-loaded')) {
      this.DropdownComponent = new DropdownComponent();
      this.SizeTableSwitcherComponent = new SizeTableSwitcherComponent();
      this.DropdownComponent.render();
      this.SizeTableSwitcherComponent.render();
      document.body.classList.add('vex-components-loaded');
    }
  }

    /**
   * Reposition modal if it goes out of viewport after accordion expansion
   */
  repositionSizeGuideModal() {
    const $modal = $('.vex.size-guide .vex-content');
    if ($modal.length === 0) return;

    const modalHeight = $modal.outerHeight();
    const viewportHeight = $(window).height();
    const modalTop = $modal.offset().top;
    const modalBottom = modalTop + modalHeight;

    // Check if modal is going out of viewport
    $modal.toggleClass('adjusted', modalBottom > viewportHeight || modalTop < 0);
    // if () {
      // // Reset transform and position modal to fit in viewport
      // $modal.css({
      //   'top': '20px',
      //   'transform': 'translateX(-50%)',
      //   'max-height': `${viewportHeight - 40}px`,
      //   'overflow-y': 'auto'
      // });

      // // Ensure the modal content is scrollable if needed
      // const $modalBody = $modal.find('.modal-body, .l-size-guide');
      // if ($modalBody.length > 0) {
      //   $modalBody.css({
      //     'max-height': `${viewportHeight - 120}px`,
      //     'overflow-y': 'auto'
      //   });
      // }
    // }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    // If algolia params are stored remove them
    removeAlgoliaAttributes();
  }

}
